export default {
  get: `query getOffices {
          getOffices
          {
            id,
            name,
            startDate,
            closeDate,
            country
          }
        }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/office.js